import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { BASE_URL } from './utils';

export class CreateExercises extends Component {
  constructor(props) {
    super(props);

    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangeDescription = this.onChangeDescription.bind(this);
    this.onChangeDuration = this.onChangeDuration.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      username: '',
      description: '',
      duration: '',
      date: new Date(),
      users: [],
    };
    this.userInput = React.createRef();
  }

  //when the component mount get the list of all the users, this is used to populate the dropdown menu
  componentDidMount() {
    axios.get(`${BASE_URL}/users`).then((response) => {
      if (response.data.length > 0) {
        this.setState({
          users: response.data.map((user) => user.username),
          username: response.data[0].username,
        });
      }
    });
    this.userInput.current.focus();
  }

  //onChange functions grabs whatever the user types or selects
  onChangeUsername(e) {
    this.setState({
      username: e.target.value,
    });
  }

  onChangeDescription(e) {
    this.setState({
      description: e.target.value,
    });
  }

  onChangeDuration(e) {
    this.setState({
      duration: e.target.value,
    });
  }

  onChangeDate(date) {
    this.setState({
      date: date,
    });
  }

  //when the submit button is clicked new exercise is created and page is redirected to homepage
  onSubmit(e) {
    e.preventDefault();

    const exercise = {
      username: this.state.username,
      description: this.state.description,
      duration: this.state.duration,
      date: this.state.date,
    };

    axios
      .post(`${BASE_URL}/exercises/add`, exercise)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    this.setState({
      username: '',
      description: '',
      duration: '',
    });
    window.location = '/';
  }

  render() {
    return (
      <div>
        <h3>Create New Exercise Log</h3>
        <form onSubmit={this.onSubmit}>
          <div className='form-group'>
            <label>Username: </label>
            <select
              ref={this.userInput}
              required
              className='form-control custom-select'
              value={this.state.username}
              onChange={this.onChangeUsername}
            >
              {this.state.users.map(function (user) {
                return (
                  <option key={user} value={user}>
                    {user}
                  </option>
                );
              })}
            </select>
          </div>

          <div className='form-group'>
            <label>Description: </label>

            <input
              type='text'
              required
              className='form-control'
              value={this.state.description}
              onChange={this.onChangeDescription}
            />
          </div>

          <div className='form-group'>
            <label>Duration (in minutes): </label>
            <input
              type='text'
              className='form-control'
              placeholder='0'
              value={this.state.duration}
              onChange={this.onChangeDuration}
            />
          </div>
          {/* use the DatePicker to select date */}
          <div className='form-group'>
            <label>Date: </label>
            <div>
              <DatePicker selected={this.state.date} onChange={this.onChangeDate} />
            </div>
          </div>

          <div className='form-group'>
            <input type='submit' value='Create New Exercise' className='btn btn-dark' />
          </div>
        </form>
        <footer className='position-absolute bottom-0 end-0'>
          <p className='footer-text'>Developed By Marsiya Issah: masy370@gmail.com</p>
        </footer>
      </div>
    );
  }
}

export default CreateExercises;
